class AjaxCancellerServ {

    constructor($q) {
        this.$q = $q;
    }
	
	generateCanceller() {
        var canceller = this.$q.defer();
        return canceller;
    }

    cancelPendingRequests(cancellers) {
        for (var i = 0, len = cancellers.length; i < len; i++) {
            cancellers[i].resolve();
        }
    }
}

AjaxCancellerServ.$inject = ['$q'];

export default AjaxCancellerServ;